import { useEffect, useState } from 'react';
import GameConnection from 'game/connection';

const LOADING = { game: null, player: null, superAdmin: false, connected: false, error: null };

// Opens a connection to the game for as long as the component is mounted
export default (code) => {
    const [connection, setConnection] = useState(null);
    const [view, setView] = useState(LOADING);

    useEffect(() => {
        const nextConnection = new GameConnection(code);
        const unsubscribe = nextConnection.subscribe(setView);

        setConnection(nextConnection);
        setView(nextConnection.view);

        return () => {
            unsubscribe();
            nextConnection.close();
        };
    }, [code]);

    return { ...view, connection };
};
